import axios from 'axios'
import {actionTypes} from '@/commons/constants'

export default {
    async [actionTypes.RELATORIO.GERAR_SIGNATARIOS_PENDENCIA_ASSINATURA]({commit, state}) {
        const organizacaoId = state.login.organizacaoPlano.organizacaoId
        const response = await axios.get(`api/relatorios/csv/signatarios/pendencia/assinatura/organizacao/${organizacaoId}`, {responseType: 'blob'})
            .catch(async function (error){
                return JSON.parse(await error.response.data.text())
            })

        if (response.message) {
            return response
        }

        const urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;

        if (urlCreator) {
            return urlCreator.createObjectURL(response.data)
        }
    },
    async [actionTypes.RELATORIO.GERAR_VIGENCIA_DOCUMENTO]({commit, state}, {filtroVigencia}) {
        const organizacaoId = state.login.organizacaoPlano.organizacaoId
        const response = await axios.get(`api/relatorios/csv/vigencia/documentos/organizacao/${organizacaoId}?vigencia=${filtroVigencia}`, {responseType: 'blob'})
            .catch(async function (error){
                return JSON.parse(await error.response.data.text())
            })

        if (response.message) {
            return response
        }

        const urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;

        if (urlCreator) {
            return urlCreator.createObjectURL(response.data)
        }
    }
}